var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/White/Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "G01",
    transform: "translate(-75.000000, -74.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0080193,79.2582794 C85.0032346,79.2582794 85.9579208,79.6538137 86.6611762,80.3578197 C87.3644317,81.0610751 87.7607165,82.0157613 87.7607165,83.0109766 C87.7607165,84.0069425 87.3644317,84.9616287 86.6611762,85.6648841 C85.9571702,86.3681396 85.0024841,86.7636739 84.0080193,86.7636739 C83.0135545,86.7636739 82.0581178,86.3688901 81.3548623,85.6648841 C80.6516069,84.9616287 80.255322,84.006192 80.255322,83.0109766 C80.255322,82.0157613 80.6516069,81.0610751 81.3548623,80.3578197 C82.0588683,79.6538137 83.0135545,79.2582794 84.0080193,79.2582794 Z M76.4373279,87.8827282 L76.4823602,87.9480251 C76.5371496,88.0298339 76.5941906,88.1101417 76.6519821,88.1979548 L83.1719183,97.5646871 C83.3625554,97.8378835 83.6747798,98 84.0080193,98 C84.3412588,98 84.6527327,97.8378835 84.8433697,97.5646871 L91.3482951,88.2054602 C91.4105899,88.1176471 91.4698825,88.0320856 91.5306762,87.95478 L91.5704548,87.8954874 L91.5704548,87.8947368 C92.7480512,86.0731776 93.2283964,83.8876067 92.9229269,81.7395628 C92.6182079,79.5915189 91.5479386,77.6266066 89.9102615,76.2043344 C88.2725844,74.7828126 86.1755772,74 84.0065182,74 C81.8374592,74 79.7412025,74.7828126 78.1027749,76.2043344 C76.4643473,77.6266066 75.394078,79.5915189 75.089359,81.7395628 C74.78464,83.8876067 75.2649852,86.0724271 76.4425816,87.8947368 L76.4373279,87.8827282 Z",
    id: "Icon/White/Location"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/White.09a42723c14594774e2d221d1703008a.svg";
export { ForwardRef as ReactComponent };